<template>
  <div style="height: 700px;">
    <div id="mapObj" style="height: 100%; width: 100;z-index:6"></div>
<!--    <l-map ref="mapRef"-->
<!--        style="height: 100%; width: 100%" :options="{editable: true}"-->
<!--        :zoom="zoom" :center="center">-->
<!--      <l-tile-layer :url="url"></l-tile-layer>-->
<!--    </l-map>-->
  </div>
</template>

<script>
import L from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet"
import 'leaflet-draw'
import 'leaflet-control-geocoder'
import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet-control-geocoder/dist/Control.Geocoder.css'
import store from '@/store'

import { computed, onMounted, onUnmounted, ref, watch } from '@vue/composition-api'
import mapDrawGeofences from '@/views/modules/maps/mapDrawGeofences'
import mapLayers from '@/views/modules/maps/functions/mapLayers'
import './geosControl'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen.js';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
export default {
  name: "Example",
  props: ['areas'],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip
  },

  setup(props, {root}) {

    // POLYGON((24.981447853927307 41.85010460969072, 23.898360304462926 41.685569726391755, 23.846278395641747 43.98905809257732, 25.02732905820092 43.957416768865976, 24.981447853927307 41.85010460969072))
    // CIRCLE (25.468055493748338 40.98313234000009, 115893.7)

    const zoom = 10
    const center = [21.4498898, 39.4913321]
    const bounds = null

    const editableLayers = ref(null)
    const mapRef = ref(null)

    const geofenceData = computed(() => store.state.geofence.data)

    const areas = ref([]);

    const map = ref({})

    store.dispatch('geofence/fetchAllGeofences').then(r => {
      areas.value = r
    })


    onMounted(() => {

      root.$nextTick(() => {

        const baseLayers = mapLayers()

        map.value = L.map('mapObj', {
           fullscreenControl: true,
          center: center,
          zoom: zoom,
          editable: true,
          layers: [baseLayers.osm],
          fadeAnimation: true,
          zoomAnimation: false
        })

        const scale = L.control.scale()
        scale.addTo(map.value)

        // L.control.search({data : areas}).addTo(map.value)

        L.control.layers(baseLayers, {},{
          position: 'topleft'}).addTo(map.value)

        L.Control.geocoder({ defaultMarkGeocode: false })
        .on('markgeocode', e => {

         const img = require('@/assets/points/moving.svg')
         const icon = L.divIcon({
           html: L.Util.template(`<img src="${img}" alt="">`),
           iconSize    : [30, 40], })

         L.marker(e.geocode.center,{icon: icon}).addTo(map.value)
         map.value.fitBounds(e.geocode.bbox)

       }).addTo(map.value)

        editableLayers.value = new window.L.FeatureGroup().addTo(map.value)
        const drawControl = new window.L.Control.Draw({
          position: 'topright',
          edit: { featureGroup: editableLayers.value, },
          draw: { polygon: true, rectangle: false, marker: false, circlemarker: false }
        });

        map.value.addControl(drawControl);

        map.value.on(window.L.Draw.Event.CREATED, (e) => {
          if (editableLayers.value.getLayers().length > 0) confirm(e)
          else draw(e)
        })

        map.value.on(window.L.Draw.Event.EDITED, (e) => {
          // console.log('on  edit',e)
          const layers = e.layers;
          layers.eachLayer(function (layer) {
            if (layer instanceof L.Polygon){
              const points = layer.getLatLngs()[0]
              points.push(points[0])
              store.commit('geofence/UPDATE_AREA', polygonStr(points))
            }

            else if (layer instanceof L.Polyline){
              const points = layer.getLatLngs()
              store.commit('geofence/UPDATE_AREA', polyLineStr(points))
            }

            else if (layer instanceof L.Circle){
              const latLang = layer.getLatLng()
              const Radius = layer.getRadius()
              store.commit('geofence/UPDATE_AREA', circleStr(latLang, Radius))
            }
          });
        })

        extractShapePoints(map.value)

      })

    })


    // const { drawArea } = mapDrawGeofences(map)

    watch( () => geofenceData.value, () => {
      extractShapePoints(map.value)
    })

    // watch(areas, () => {
    //   areas.value.map(a => {
    //
    //     console.log(a.id)
    //     console.log(a.geofence_id)
    //     if (a.geofence_id !== 12579) {
    //       drawArea(a)
    //     }
    //   })
    // })

    const extractShapePoints = (map) => {
      const area = geofenceData.value.area      
      const type = area.slice(0,1)     
      const color = geofenceData.value.attributes.filter((v, i) => v.key === 'color')
      const options = {  weight: 4, ...(color.length > 0 && {fillColor: color[0]['value']}), fillOpacity: 0.3, opacity: 1, color: 'black'}

      switch(type) {
        case 'C':
          const { latLng, r } = ExtractCircleData(area)
          const c = L.circle([parseFloat(latLng[0]), parseFloat(latLng[1])], {...options,  radius: r})
          editableLayers.value.addLayer(c)
            setTimeout(() => {
              map.invalidateSize()
              map.fitBounds(c.getBounds())
            }, 1000)
          break
        case 'P':
          const points = extractPolygonData(area)
          const P = L.polygon(points.map((v, i) => [
                  parseFloat(v.split(' ')[0]), parseFloat(v.split(' ')[1])]), options)
          editableLayers.value.addLayer(P)
          // P.enableEdit()
          setTimeout( () => {
            // map.invalidateSize()
            map.fitBounds(P.getBounds())
          }, 1000);

          break
        case 'L':
          const linePoints = extractLineData(area)
          const Line = L.polyline(linePoints.map((v, i) => [
            parseFloat(v.split(' ')[0]), parseFloat(v.split(' ')[1])]), options)
          editableLayers.value.addLayer(Line)
          setTimeout( () => {
            map.invalidateSize()
            map.fitBounds(Line.getBounds())
          }, 1000);
          break
      }
    }


    const extractPolygonData = (area) => {
      return area.split('((')[1].slice(0, -2).split(', ')
    }

    const extractLineData = (area) => {
      return area.split('(')[1].slice(0, -1).split(', ')
    }


    const ExtractCircleData = (area) => {
      const points = ((area.split('(')[1]).slice(0, -1)).split(', ')
      const latLng = points[0].split(' ')
      const r = points[1]

     return {
        latLng, r
     }
    }


    const drawCircle = (layer) => {
      const latLang = layer.getLatLng()
      const Radius = layer.getRadius()
      store.commit('geofence/UPDATE_AREA', circleStr(latLang, Radius))
      editableLayers.value.addLayer(layer)
    }

    const drawLine = (layer) => {
      const points = layer.getLatLngs()
      store.commit('geofence/UPDATE_AREA', polyLineStr(points))
      editableLayers.value.addLayer(layer)
    }


    const drawPolygon = (layer) => {
      let points = layer.getLatLngs()[0]
      points.push(points[0])
      store.commit('geofence/UPDATE_AREA', polygonStr(points))
      editableLayers.value.addLayer(layer)
    }


    const draw = (e) => {
      if (e.layerType  === 'polyline') drawLine(e.layer)
      else if (e.layerType === 'polygon') drawPolygon(e.layer)
      else if (e.layerType === 'circle') drawCircle(e.layer)
    }

    const confirm = (e) => {
      root.$swal({
        title: root.$i18n.t("Just one Shape!"),
        text: root.$i18n.t("Do you want to Replace old shape with new one ?"),
        showCancelButton: true,
        confirmButtonText: root.$i18n.t('Yes, Replace it!'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          editableLayers.value.clearLayers()
          draw(e)
        }
      })
    }


    const polyLineStr = (points) => {
      
      let str = ''
      for (const i in points)
        str+= `${points[i].lat} ${points[i].lng}, `
   
      return `LINESTRING (${str.slice(0, -2)})`
    }

    const polygonStr = (points) => {
      let str = ''
      for (const i in points)
        str+= `${points[i].lat} ${points[i].lng}, `

      // console.log(`POLYGON((${str.slice(0, -2)}))`)
      return `POLYGON((${str.slice(0, -2)}))`
    }

    const circleStr = (points, r) => `CIRCLE (${points.lat} ${points.lng}, ${r})`

    return {
      zoom,
      center,
      bounds,
      mapRef
    }
  }

};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/map-leaflet.scss';

.leaflet-editing-icon {
  width: 10px !important;;
  height: 10px !important;;
  margin-left: -5px !important;
  margin-top: -5px !important;
  border-radius: 5px;
}

.leaflet-control-layers-toggle {
  width: 30px !important;
  height: 30px !important;
  background-size: 20px 20px;
}


</style>
